import { customRef, reactive, ref, isRef, computed, watch, toRefs, unref } from 'vue'

export default function useStoreItem (props, Store) {
  const options = { local: props.local }
  const { patch, get } = Store

  const id = isRef(props.id) ? props.id : ref(props.id)
  const reference = computed(() => JSON.parse(JSON.stringify(get(id.value))))

  let item = reactive({
    ...reference.value,
  })

  let updatedAt = ref(reference.value.__updated_at)

  watch(() => reference.value, (newValue, oldValue) => {
    if (newValue?.__updated_at !== oldValue?.__updated_at) {
      for (const key in newValue) {
        if (Object.prototype.hasOwnProperty.call(newValue, key)) {
          // if (item)
          item[key] = newValue[key]// JSON.parse(JSON.stringify(newValue[key]))
        }
      }

      updatedAt.value = reference.value.__updated_at
    }
  }, { immediate: false })

  watch(() => item, (newValue, oldValue) => {
    if (updatedAt.value === reference.value.__updated_at) {
      console.log('yo')
      patch(
        id.value, 
        JSON.parse(JSON.stringify({ 
          ...newValue, 
          __updated_at: reference.value.__updated_at
        })), 
        options
      )
    }
  }, { deep: true, immediate: false })

  return toRefs(item)
} 
